document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[id^="CollectionLoadMore-"]');

  if (!buttons.length) return;

  buttons.forEach((button) => {
    const sectionId = button.dataset.sectionId;
    const productList = document.getElementById(`product-list-${sectionId}`);

    if (!productList) return;

    button.addEventListener('click', function () {
      const nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Laster…';

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Finn samme seksjon på neste side
          const newProductList = doc.getElementById(`product-list-${sectionId}`);
          const newButton = doc.getElementById(`CollectionLoadMore-${sectionId}`);

          if (newProductList) {
            const tempWrapper = document.createElement('div');
            tempWrapper.innerHTML = newProductList.innerHTML;

            tempWrapper
              .querySelectorAll('[reveal-on-scroll="true"]')
              .forEach((el) => {
                el.removeAttribute('reveal-on-scroll');
                el.style.opacity = '1';
              });

            while (tempWrapper.firstChild) {
              productList.appendChild(tempWrapper.firstChild);
            }
          }

          if (newButton && newButton.dataset.nextUrl) {
            button.setAttribute('data-next-url', newButton.dataset.nextUrl);
            button.disabled = false;
            button.textContent = originalText;
          } else {
            button.remove();
          }
        })
        .catch((error) => {
          console.error('Load more error:', error);
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  });
});
